interface ITitlePageProps extends React.HTMLProps<HTMLElement> {
  expand?: boolean;
}

function IconExpand(){
  return <></>
}

export default function TitlePage({children, expand}:ITitlePageProps){
  return (
    <div className="pagedefault-title">
      {expand?(<IconExpand/>):""}
      {children}
    </div>
  )
}